var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import HeaderRow from "../HeaderRow";
import { styleBlock } from "../styleBlock";
const SideNav = (_a) => {
    var { className, activeId, links, additionalParts } = _a, props = __rest(_a, ["className", "activeId", "links", "additionalParts"]);
    const classNames = styleBlock("sidenav").mix(className);
    const activeItem = activeId && links
        ? links.filter(point => {
            return point.id === activeId;
        })[0]
        : null;
    const createItems = (links) => {
        return links.map((link, idx) => {
            let className = link.className ? "with-icon " + link.className : "without-icon ";
            className += activeId === link.id ? " active" : "";
            return (React.createElement(Dropdown.Item, { className: className, href: link.href, onClick: link.onClick, key: "sidenav-" + idx },
                link.title,
                " ",
                link.suffix && React.createElement("span", { className: "text-right text-danger font-size-sm text-float-right" }, link.suffix)));
        });
    };
    const moreLinks = additionalParts &&
        additionalParts.map((part) => part.links &&
            part.links.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(Dropdown.Divider, null),
            part.label && React.createElement(HeaderRow, { title: part.label, level: 2, size: "display-4", className: "pb-2" }),
            part.links && createItems(part.links))));
    return (React.createElement("div", { role: "navigation", "aria-label": props["aria-label"], className: classNames.toString() },
        React.createElement(Dropdown, null,
            React.createElement(Dropdown.Toggle, { id: "dropdown-sidenav" }, activeItem && React.createElement("span", { className: "active with-icon " + activeItem.className }, activeItem.title)),
            React.createElement(Dropdown.Menu, { renderOnMount: true, onSelect: () => null },
                links && createItems(links),
                moreLinks))));
};
export default SideNav;
//# sourceMappingURL=index.js.map